import { render } from "./BorrowBody.vue?vue&type=template&id=9e3abb32&scoped=true"
import script from "./BorrowBody.vue?vue&type=script&lang=js"
export * from "./BorrowBody.vue?vue&type=script&lang=js"

import "./BorrowBody.vue?vue&type=style&index=0&id=9e3abb32&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3abb32"]])

export default __exports__